export const XANTHOS_FILE_TYPES = [
    {code: 'WSN', description: 'Work Status Note'},
    {code: 'MR', description: 'Mileage Reimbursement'},
    {code: 'PR', description: 'Prescription Reimbursement'},
    {code: 'MA', description: 'Medical Authorization'},
    {code: 'WI', description: 'Wage Information'},
    {code: 'P', description: 'Photos'},
    {code: 'O', description: 'Other'}];
export const XANTHOS_FILE_EXTENSIONS = ['pdf'];
